import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Dialog, DialogActions } from '@mui/material';
import React from 'react';

interface Props {
  children: React.ReactNode;
  isOpen: any;
  handleClose: any;
  onSubmit?: any;
  isValid?: boolean;
  isLoading?: boolean;
  closeContent?: string;
  okContent?: string;
}

/** A reusable dialog component based on the dialog from material ui. */
export const PathDialog: React.FC<Props> = ({
  children,
  isOpen,
  handleClose,
  onSubmit,
  isValid,
  isLoading,
  closeContent = 'Close',
  okContent = 'OK',
}) => {
  return (
    <Dialog open={isOpen}>
      {children}
      <DialogActions>
        <Button onClick={handleClose}>{closeContent}</Button>
        {onSubmit && (
          <LoadingButton
            onClick={onSubmit}
            disabled={!isValid}
            loading={isLoading}
            variant="contained"
            color="primary"
          >
            {okContent}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
};
